import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import { curvedSmoothing } from "./server-data";

let serverData = window.__server_data__ || {};

if (process.env.NODE_ENV === "development") {
  serverData = require("./server-data").default();
} else {
  // Server data rendered in footer with PHP contains everything except
  // smoothing function
  serverData[0].options.smoothing = curvedSmoothing;
}

const script = document.getElementById("__server_data__");
if (script) script.parentElement.removeChild(script);

ReactDOM.render(
  <App serverData={serverData} />,
  document.getElementById("root")
);
